import type { Signer, TransactionInstruction } from "@solana/web3.js";

/**
 * Container for a transaction and its signers.
 */
export interface TransactionEnvelope {
  instructions: TransactionInstruction[];
  signers?: Signer[];
}
